import { Component } from '@angular/core';

@Component({
    selector: 'app-time-sync-admin',
    templateUrl: './time-sync-admin.component.html',
    styleUrls: ['./time-sync-admin.component.scss'],
    standalone: false
})
export class TimeSyncAdminComponent {

}
